import { connect } from "react-redux";

import { post } from "../../../../../../../actions/general";
import { editTask } from "../../../../../../../store/plan/actions";

import Same from "./Same";

export default connect(null, { post, editTask })(Same);
